import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getContentHeaders, postContentHeaders} from '../common/headers';
import {AuthHttp} from 'angular2-jwt';
import {BaseService} from '../base/service.base';
import {User} from '../models/user.model';
import {Observable} from 'rxjs/Observable';
import {share} from 'rxjs/operator/share';

@Injectable()
export class UserService extends BaseService {
  private _users$: BehaviorSubject<User[]>;
  private _dataStore: {
    users: User[]
  };

  constructor(private _http: AuthHttp) {
    super();
    this._dataStore = {users: []};
    this._users$ = <BehaviorSubject<User[]>>new BehaviorSubject([]);
  }

  get users$() {
    return this._users$.asObservable();
  }

  public loadAll(filter: string = '') {
    this._http.get(`${this.baseApiUrl}/users${filter}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.users = result;
      this._users$.next(this._dataStore.users);
    }, error => console.error('Could not load users.'));
  }

  public load(id: any) {
    this._http.get(`${this.baseApiUrl}/users/${id}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      let notFound = true;

      this._dataStore.users.forEach((item, index) => {
        if (item._id === result._id) {
          this._dataStore.users[index] = result;
          notFound = false;
        }
      });

      if (notFound) {
        this._dataStore.users.push(result);
      }

      this._users$.next(this._dataStore.users);
    }, error => console.error('Could not load user.'));
  }

  public create(user: User): Observable<any> {
    const shareable = this._http.post(`${this.baseApiUrl}/users`, JSON.stringify(user),
      {headers: postContentHeaders}).map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.users.push(result);
      this._users$.next(this._dataStore.users);
    }, error => console.error('Could not create user.'));

    return shareable;
  }

  public update(user: User): Observable<any> {
    const shareable = this._http.put(`${this.baseApiUrl}/users/${user._id}/admin`, JSON.stringify(user), {headers: postContentHeaders})
      .map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.users.forEach((defi, i) => {
        if (defi._id === result._id) {
          this._dataStore.users[i] = result;
        }
      });

      this._users$.next(this._dataStore.users);
    }, error => console.error('Could not update user.'));

    return shareable;
  }

  public updatePassword(user: User): Observable<any> {
    const shareable = this._http.put(`${this.baseApiUrl}/users/${user._id}/password`, JSON.stringify(user), {headers: postContentHeaders})
      .map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.users.forEach((defi, i) => {
        if (defi._id === result._id) {
          this._dataStore.users[i] = result;
        }
      });

      this._users$.next(this._dataStore.users);
    }, error => console.error('Could not update user.'));

    return shareable;
  }

  public remove(userId: string): Observable<any> {
    const shareable = this._http.delete(`${this.baseApiUrl}/users/${userId}`).share();
    shareable.subscribe(response => {
      this._dataStore.users.forEach((t, i) => {
        if (t._id === userId) {
          this._dataStore.users.splice(i, 1);
        }
      });

      this._users$.next(this._dataStore.users);
    }, error => console.error('Could not delete user.'));

    return shareable;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/users.service.ts